import type { IconName } from '@nexus/ui';

/** A search hit opened recently. Kept only in this browser, per account (search.md). */
export interface RecentHit {
  title: string;
  path: string;
  icon: IconName;
}

const PREFIX = 'staw.search.recent.';
const MAX = 6;

function key(accountId: string): string {
  return `${PREFIX}${accountId}`;
}

export function recentHits(accountId: string): RecentHit[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(key(accountId)) ?? '[]');
    return Array.isArray(value) ? (value as RecentHit[]).slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function rememberHit(accountId: string, hit: RecentHit): void {
  try {
    const rest = recentHits(accountId).filter((h) => h.path !== hit.path);
    localStorage.setItem(key(accountId), JSON.stringify([hit, ...rest].slice(0, MAX)));
  } catch {
    // Storage may be full or blocked; the list is only a convenience.
  }
}

/** On sign-out: the next person on a shared device does not see what was opened. */
export function forgetRecentHits(): void {
  try {
    for (const name of Object.keys(localStorage)) {
      if (name.startsWith(PREFIX)) localStorage.removeItem(name);
    }
  } catch {
    // See rememberHit.
  }
}
